export default "__VITE_ASSET__BJihYl7i__"